module.exports = __webpack_public_path__ + "img/ghonaim-ecosystem.18649e92.webp";